import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'service-mode-modal-dialog',
    templateUrl: 'service-mode-modal-dialog.component.html',
    standalone: false
})

export class ServiceModeModalDialogComponent {

  public titleHeader: string = null;
  public title: string;
  public accept: boolean = false;

  constructor(public dialogRef: MatDialogRef<ServiceModeModalDialogComponent>)
  {
  }

  public closeDialog() {
      this.dialogRef.close();
  }

  public save() {
    this.accept = true;
    this.closeDialog();
  }
}
